import React from "react"
import icon from "images/icons/icon-filter.svg"

export default function FilterIcon({ title }) {
  return (
    <span
      className="svg-icon"
      title={title}
      dangerouslySetInnerHTML={{ __html: icon }}
    />
  )
}
